import Head from "next/head";

export default function HomePage() {
	return (
		<>
			<Head>
				<title>Moment</title>
				<meta name="description" content="Docs, reimagined for developers." />
			</Head>
		</>
	);
}
